import { useInboundAllocationRequestCount } from '@hooks/other/useInboundAllocationRequests';
import { useInboundRegistrarServiceRequests } from '@hooks/other/useInboundRegistrarServiceRequests';
import { useInboundTransferOffers } from '@hooks/other/useInboundTransferOffers';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge, Box, IconButton, Popover, Typography } from '@mui/material';
import { NotificationRow } from './NotificationRow';

export const Notifications: React.FC = () => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const nav = useNavigate();
  // registry
  const transfers = useInboundTransferOffers();
  const allocations = useInboundAllocationRequestCount();
  const registrars = useInboundRegistrarServiceRequests();
  const showNotification = registrars.length || transfers.length || allocations;
  const goAllocations = () => {
    nav('/registry/allocationRequest');
  };
  const goTransfers = () => {
    nav('/registry/transfers');
  };
  const goRegistryOnboarding = () => {
    nav('/registry/onboarding');
  };
  const notifications: { label: string; onClick: () => void; count: number }[] = [
    {
      label: 'Allocation requests',
      onClick: goAllocations,
      count: allocations,
    },
    {
      label: 'Transfer requests',
      onClick: goTransfers,
      count: transfers.length,
    },
    {
      label: 'Registrar requests',
      onClick: goRegistryOnboarding,
      count: registrars.length,
    },
  ];
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'notification-popover' : undefined;
  return (
    <>
      <IconButton
        aria-label="notifications"
        size="small"
        sx={{ display: 'flex', alignItems: 'center' }}
        onClick={handleClick}
      >
        <Badge
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          showZero
          variant="dot"
          color="error"
          invisible={!showNotification}
        >
          <NotificationsIcon fontSize="small" />
        </Badge>
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box sx={{ p: 2, width: '300px' }}>
          {!showNotification && (
            <Typography variant="body2" sx={{ textAlign: 'center', p: 0 }}>
              No notifications
            </Typography>
          )}
          {notifications.map((n) => (
            <NotificationRow
              key={n.label}
              label={n.label}
              onClick={() => {
                n.onClick();
                handleClose();
              }}
              count={n.count}
            />
          ))}
        </Box>
      </Popover>
    </>
  );
};
